import React, {useEffect} from 'react';
import ReactTooltip from "react-tooltip";
import {useSelector} from "react-redux";

import BookingList_Tabs from "./Tabs/BookingList_Tabs";
import BookingList_Search from "./Tabs/BookingList_Search";
import useSortableData from "../../utils/sortableData";
import useFilteredData from "../../utils/subfilteredData";
import {BookingList_Item_Memo} from "./Item/BookingList_Item";
import BookingList_SortHeaders from "./BookingList_SortHeaders";
import useBookingListNavigation from "../../utils/bookingListNavigation";

const BookingList = () => {
    const {pushBookingListUrl} = useBookingListNavigation();
    const {bookings, sortColumn, sortMode, status} = useSelector(state => state.bookingList);
    const {filteredItems} = useFilteredData(bookings);

    const { items, requestSort, getClassNamesFor } = useSortableData(pushBookingListUrl, filteredItems, {key: sortColumn, direction: sortMode});

    const renderRow = (booking, key) => <BookingList_Item_Memo key={key} booking={booking}/>

    useEffect(() => {
        ReactTooltip.rebuild();
    });

    return (
        <main className="main">
            <div className="container booking-list">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <h1 className="h2">Booking List</h1>
                        <div className="table-holder bg-white rounded shadow-sm border">
                            <BookingList_Tabs />
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1">
                                    <BookingList_Search />
                                    <table className="table procedure-list-table" cellSpacing="0" width="100%">
                                        <BookingList_SortHeaders _requestSort={requestSort} _getClassNamesFor={getClassNamesFor}/>
                                        <tbody>
                                            {items.map(renderRow)}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default BookingList;